import { ElementType, ComponentPropsWithoutRef, useMemo } from "react";
import clsx from "clsx";
import { createSpacingClasses, SpacingProps } from "@theme/spacing.ts";

type PolymorphicProps<E extends ElementType> = {
  as?: E;
} & SpacingProps &
  Omit<ComponentPropsWithoutRef<E>, keyof SpacingProps>;

export const GridContainer = <E extends ElementType = "div">({
  as,
  className,
  style,
  ...rest
}: PolymorphicProps<E>) => {
  const Component = as || "div";

  const classNames = useMemo(() => {
    const spacingClasses = createSpacingClasses(rest);
    return [...spacingClasses].join(" ");
  }, [rest]);

  return (
    <Component
      className={clsx("base-grid", className, classNames)}
      style={{
        ...style,
      }}
      {...rest}
    />
  );
};
